import { Redirect } from 'aurelia-router';

class AppRoutingStep {
  constructor(router, appRouting) {
    'inject';

    this._router = router;
    this._appRouting = appRouting;
  }
  run(navigationInstruction, next) {
    let failedValidation = null;
    navigationInstruction.getAllInstructions()
    .some((route) => {
      const validation = this._appRouting.validate(route.config.settings);
      if (validation.denied) {
        failedValidation = validation;
      }

      return validation.denied;
    });

    return failedValidation ?
      next.cancel(new Redirect(this._router.generate(failedValidation.redirectTo))) :
      next();
  }
}

export { AppRoutingStep };
